/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import restClient from '../../app/helpers/restClient';

// Fetch status from mongo
const fetchPassportAutoRenewalStatusApi = async (wcEnv, jwtToken, payload, params, headers) => {
    const resourcePage = `retention-subscription/passport/fetch-passport-auto-renew/${payload}`;

    return restClient.getFacade(wcEnv, resourcePage, jwtToken, params, headers, false)
        .then((response) => response.data);
};

export default fetchPassportAutoRenewalStatusApi;
